import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { sanitizeHtml } from "../../utils/sanitize";
import { useAlert } from "react-alert";

import { getFaqs } from "../../actions/faqActions";
import Loader from "../Loader";
import "./faq.css";

const FAQs = ({ history }) => {
  const alert = useAlert();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getFaqs());
  }, [dispatch, alert]);

  const { faqs, loading, error } = useSelector((state) => state.faqs);

  // Add debug logging
  useEffect(() => {}, [faqs, loading, error]);

  return (
    <Fragment>
      <section
        className="page-banner-sec text-center"
        style={{
          backgroundImage: `url("../assets/frontend/img/about-banner.jpg")`,
        }}
      >
        <div className="container">
          <ul className="clearfix paginations-cust">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/faqs">FAQs</Link>
            </li>
          </ul>
          <h1>Frequently Asked Questions</h1>
        </div>
      </section>

      <section className="faq-page-sec">
        <div className="container">
          {loading ? (
            <Loader />
          ) : (
            <div className="row">
              {faqs && faqs.length > 0 ? (
                faqs.map((item, key) => {
                  const indexId = key + 1;
                  return (
                    <Fragment key={item._id || indexId}>
                      <div className="col-sm-12 mb-4">
                        <div className="faq-item">
                          <h3 className="faq-question">{item.question}</h3>
                          <div
                            className="faq-answer"
                            dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.answer) }}
                          ></div>
                        </div>
                      </div>
                    </Fragment>
                  );
                })
              ) : (
                <div className="col-sm-12">
                  <p>No FAQs available at the moment.</p>
                </div>
              )}
            </div>
          )}
        </div>
      </section>
    </Fragment>
  );
};

export default FAQs;
